export const FF_TEMP_CO_DATE_OF_BIRTH = 'ff_temp_co_date_of_birth';
export const FF_TEMP_CO_STEPPER_GA_TRACK = 'ff_temp_co_stepper_ga_track';
export const FF_CART_CRITEO_ON_THANK_YOU_PAGE_V2 = 'FF_CART_CRITEO_ON_THANK_YOU_PAGE_V2';
export const FF_COBA_3DS_ADYEN = 'ff_coba_3ds_adyen';
export const FF_CHECKOUT_ADDRESS_VALIDATION_V2 = 'FF_CHECKOUT_ADDRESS_VALIDATION_V2';
export const FF_CHECKOUT_AUTH_PAYMENT_V2 = 'FF_CHECKOUT_AUTH_PAYMENT_V2';
export const FF_CHECKOUT_GET_PAYMENT_METHODS_V2 = 'FF_CHECKOUT_GET_PAYMENT_METHODS_V2';
export const FF_ADD_TO_CART_ON_APP_CART = 'FF_ADD_TO_CART_ON_APP_CART';
export const FF_CHECKOUT_MAKE_PAYMENT_V2 = 'FF_CHECKOUT_MAKE_PAYMENT_V2';
export const FF_CHECKOUT_PREVIEW_ORDER_V2 = 'FF_CHECKOUT_PREVIEW_ORDER_V2';
